import { Brand } from "@/shared/components/ui/Brand";

interface EntryHeaderProps {
  title: string;
  illustration: string;
  illustrationAlt: string;
  hideTitle?: boolean;
}

export function EntryHeader({ title, illustration, illustrationAlt, hideTitle = false }: EntryHeaderProps) {
  return (
    <header className="mb-5 flex flex-col items-center gap-4 text-center">
      <Brand wordmark className="gap-2 [&>span:first-child]:text-[44px] [&>span:last-child]:text-[32px]" />
      <img src={illustration} alt={illustrationAlt} width={100} className="h-auto w-[100px] max-w-full" />
      <h1 className={hideTitle ? "sr-only" : "text-xl font-extrabold"}>{title}</h1>
    </header>
  );
}
